import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchMpConfig, fetchMpBlocks, fetchMpStats, fetchMpRequests } from '../../lib/api';

export function useMpConfig() {
  return useQuery({
    queryKey: queryKeys.mpConfig(),
    queryFn: fetchMpConfig,
  });
}

export function useMpBlocks() {
  return useQuery({
    queryKey: queryKeys.mpBlocks(),
    queryFn: fetchMpBlocks,
  });
}

export function useMpStats() {
  return useQuery({
    queryKey: queryKeys.mpStats(),
    queryFn: fetchMpStats,
  });
}

export function useMpRequests(params) {
  const { page = 1, page_size = 50, ...filters } = params ?? {};

  return useQuery({
    queryKey: queryKeys.mpRequests(page, filters),
    queryFn: () => fetchMpRequests({ page, page_size, ...filters }),
  });
}
